// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2M3a7","errorLogs":"EditorFooter_errorLogs__28J5M"};